<template>
    <div class="relative min-h-10">
        <!-- eslint-disable-next-line -->
        <div v-html="content" v-bind="$attrs"></div>
        <PreviewLoader v-if="loading.content" />
    </div>
</template>

<script setup lang="ts">
import { toRefs, onMounted, ref, watch } from 'vue';
import PreviewLoader from './PreviewLoader.vue';

interface Props {
    type?: number | string;
}

const props = withDefaults(defineProps<Props>(), {
    type: 0,
});

const { type } = toRefs(props);

const loading = ref({
    content: true,
});

const content = ref(null);

const loadContent = () => {
    loading.value.content = true;
    axios
        .get(route('content.blocks.render', { id: type.value }), {
            params: {
                admin: true,
            },
        })
        .then(({ data }) => {
            content.value = data.content;
            loading.value.content = false;
        });
};

onMounted(() => {
    loadContent();
});

watch(type, () => {
    loadContent();
});
</script>
